<template>
    <div class="vm-group-share-card" :class="[browser_size, type]">
        <div
            class="flex-box mb8 flex-align-items-center"
            v-if="d.user && type == 'share'"
        >
            <pic
                :src="d.user.avatar"
                class="wh32 mr8 circle"
                width="32"
                height="32"
            />
            <div class="fs14 black-8">
                <span class="fwb">{{ d.user.name }}</span>
                <span v-if="d_type == 'group'" class="ml8">{{$t('c.GroupShareCard.text1')}}</span>
                <span v-if="d_type == 'album'" class="ml8">{{$t('c.GroupShareCard.text2')}}</span>
            </div>
        </div>
        <div class="cover-box wh280">
            <pic :src="d.cover" width="280" height="280" />
        </div>
        <div class="fwb fs32 mq mt-24-16 text-center">{{ d.title }}</div>
        <div v-if="d_type == 'group' && (d.member_count >= 5 || d.post_count >= 5)" class="flex-box flex-align-items-center flex-center mq fs-16-14 mt-32-16 black-8">
            <span v-if="d.post_count >= 5">{{$t('c.GroupShareCard.text4')}} {{ d.post_count }}</span>
            <div v-if="d.member_count >= 5" class="flex-box flex-align-items-center" :class="{ml24: d.post_count >= 5}">
                <span class="mr8">{{$t('c.GroupShareCard.text3')}} {{ d.member_count }}</span>
                <avatar-stack
                    v-if="members.length > 0"
                    :users="members"
                ></avatar-stack>
            </div>
            <!-- <span v-if="d.post_count >= 5">{{$t('c.GroupShareCard.text4')}} {{ d.post_count }}</span> -->
        </div>
        <div v-if="d_type == 'album' && d.content" class="flex-box flex-align-items-center mq fs-16-12 mt16 black-5 flex-center">
            {{d.content.length > 35
              ? `${d.content.substr(0, 35)}...`
              : d.content
            }}
        </div>
        <template v-if="type != 'share'">
              <div class="flex-box flex-center" v-if="!is_applying_apple && !is_applying_google">
                <btn
                    class="pl30 pt12 pr30 pb12 mt24"
                    v-if="d.type == 2"
                    @click.native="join('pay')"
                    >¥{{plan_price }} {{text_month}} {{$t('c.GroupShareCard.text6')}}</btn>
                <btn
                    class="pl30 pt12 pr30 pb12 mt24"
                    v-if="d.type == 1"
                    @click.native="join"
                    >{{$t('c.GroupShareCard.text7')}}</btn>
            </div>
            <div class="mt32 group-content-box" v-if="d.content">
                <p class="purple text-center">{{$t('c.GroupShareCard.text8')}}</p>
                <pre-box class="black-3 mt16" :text="d.content" :n="1000">{{ d.content }}</pre-box>
            </div>
        </template>
        <div class="mt16" v-if="type == 'share'">
            <div class="flex-box flex-center">
                <qriously
                    v-if="is_async_component_loaded"
                    :value="url"
                    :size="76"
                    class="qrcode flex-box flex-center"
                />
            </div>
            <div class="flex-box flex-center black-5 mt8 fs12">
                {{$t('c.GroupShareCard.text9')}}
            </div>
        </div>
    </div>
</template>

<script>
import { GET_USER_JOIN_GROUP,POST_GET_PLAN_SKUS } from "@/api/config";
import Vue from "vue";
import { mapState } from "vuex";
export default {
    props: {
        d: {
            //数据源data简称，习惯叫 d 了
            type: Object,
            default() {
                return {};
            },
        },
        plan: {
            type: Object,
            default() {
                return {};
            },
        },
        members: {
            type: Array,
            default() {
                return [];
            },
        },
        type: {
            type: String,
            default() {
                return "";
            },
        },
        d_type: {
            //数据源data简称，习惯叫 d 了
            type: String,
            default() {
                return "group";
            },
        },
    },
    data() {
        return {
            is_async_component_loaded: false,
            sku_list:[],
        };
    },
    computed: {
      ...mapState("app", [
          "browser_size",
          "session_user",
          "is_applying_apple",
          'white_list'
      ]),
      url() {
          if (this.d_type == "album") {
              return `${location.origin}/album/${this.d.album_id}`;
          }
          return `${location.origin}/group/${this.d.group_id}`;
      },
      plan_price() {
        if (this.plan.plan_id == "a103c78cc4f611ea843652540025c377") {
          return "350";
        }
        if (this.plan.plan_id == "11f87684e6b311eb86c452540025c377") {
          return "199.10";
        }
        if (this.plan.plan_id == "b5f231e2e84611ea93df52540025c377") {
          return "496.8";
        }
        if (this.plan.plan_id == "02b87afa0f0111ebaa8f52540025c377") {
          return "720";
        }
        if(this.plan.plan_id == 'a8beb5ccf14111eb99e052540025c377'){
          return "360";
        }
        if(this.plan.plan_id == 'a2de0554f14111eb834052540025c377'){
          return "90";
        }
        if (this.plan.show_price_after_adjust) { //server 调价
          return this.plan.show_price_after_adjust;
        }
        if (this.plan.pay_month > 1) {
          return this.plan.show_price;
        }
        if (this.plan.total_price) {
          return this.plan.total_price;
        }
        return this.is_year_plan
          ? this.plan.price * 12
          : this.is_q_plan
          ? this.plan.price * 3
          : this.plan.price;
      },
      is_year_plan() {
        return this.white_list.PLANS_YEAR.indexOf(this.plan.plan_id) != -1 || this.plan.pay_month == 12;
      },
      is_q_plan() {
        return this.white_list.PLANS_Q.indexOf(this.plan.plan_id) != -1 || this.plan.pay_month == 3;
      },
      text_month() {
        if (this.is_q_plan) {
          return this.$t('c.GroupShareCard.text10');
        }
        if (this.is_year_plan) {
          return this.$t('c.GroupShareCard.text11');
        }
        return this.$t('c.GroupShareCard.text5');
      },
    },
    async beforeMount() {
        let VueQriously = await import("vue-qriously");
        Vue.use(VueQriously);
        this.is_async_component_loaded = true;
    },
    mounted() {
        if(this.plan.product_type == 1){
            this.get_plan()
        }
        // console.log(this.d);
    },
    methods: {
        async get_plan() {
            if (this.$http.is_run(POST_GET_PLAN_SKUS)) {
                return false;
            }
            let data = await this.$http.$axios(POST_GET_PLAN_SKUS, {
                plan_id: this.plan.plan_id,
            });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            this.sku_list = data.data.list;
        },
        async join(type = "") {
            if (type == "pay") {
                if((this.plan.product_type == 1 || this.plan.product_type == 3) && this.sku_list.length > 0){
                    let sku = JSON.stringify([{ sku_id: this.sku_list[0].sku_id, count: 1}]);
                    this.$mixin_router_push(
                        `/order/create?plan_id=${this.plan.plan_id}&product_type=${this.plan.product_type}&sku=${sku}`
                    );
                    return false;
                }
                this.$mixin_router_push(
                    `/order/create?plan_id=${this.plan.plan_id}&product_type=${this.plan.product_type}`
                );
                return false;
            }
            if (this.$http.is_run(GET_USER_JOIN_GROUP)) {
                return false;
            }
            let data = await this.$http.$axios(GET_USER_JOIN_GROUP, {
                group_id: this.d.group_id,
            });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                if (data.ec == 40101) {
                    this.$store.commit(
                        "app/set:redirect_url",
                        this.$route.fullPath
                    );
                    this.$mixin_router_push("/login");
                }
                return false;
            }
            // this.get_group();
            this.$emit("joined");
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-group-share-card {
  padding: 56px;
  border-radius: 15px;
  box-shadow: 4px 8px 16px $black-1;
  background: $white;
  width: 280px;

  &.share {
    width: 100%;
    box-sizing: border-box;
    padding: 37px;

    .cover-box {
    }
  }

  .cover-box {
    width: 160px;
    height: 160px;
    border-radius: 8px;
    box-shadow: $layer-shadow;
    overflow: hidden;
    position: relative;
    margin: 0 auto;

    &.wh280 {
      width: 280px;
      height: 280px;
      border-radius: 10px;
    }

    img {
      position: absolute;
      object-fit: cover;
      height: 100%;
    }
  }

  &.small {
    padding: 32px;
  }
}
</style>
